export const RequestResult = {
  OK: 0,
  GeneralError: 1,
  InvalidOrMissingParameter: 2,
  // NotImplemented:  3,
  // UserExists: 7,
  NotAuthorized: 8,
  // UserInactive: 9,
  // DeviceAlreadyAssigned: 10,
  UsernameInUse: 13,
  // UserNameTooShort: 14,
  NotSupported: 15,
  UserNotExists: 16,
  InvalidLoginData: 17,
  InvalidCookie: 19,
  CookieExpired: 20,
  NoAssignedDevice: 21,
  UserRegNotConfirmed: 23,
  UserRegAlreadyConfirmed: 24,
  InvalidExpandPeriod: 25,

  Http403: 403, // 'msg' => 'HTTP 403 Forbidden'];
  Http404: 404, // 'msg' => 'HTTP 404 Not Found'];
  Http405: 405, // 'msg' => 'HTTP 405 Method Not Allowed'];
  Http415: 415, // 'msg' => 'HTTP 415 Unsupported Media Type'];
};
